<template>
  <el-container>
    <el-main style="padding: 0">
      <vm-table
          ref="vmTable"
          module="basic"
          url="productionManage/list"
          :filter.sync="filter"
          :is-height="false"
          :search-more-show="true"
          @setSelectedRow="setSelectedRow"
          @row-click="rowClick"
          @searchShow="searchShow = !searchShow"
          @update:filter="handleClick">
        <div slot="toolbar">
          <el-button :disabled="!productionOrderId" type="primary" @click="$refs.printIssue.open(orderInfo)"> 打印发料单 </el-button>
        </div>
        <template slot="adSearch">
          <div class="vm-search">
            <vm-search label="工作中心：">
              <el-input v-model.trim="filter.workCenterName" placeholder="请选择工作中心" readonly clearable>
                <el-button slot="append" icon="el-icon-search" @click="$refs.workCenterSelect.open()"/>
              </el-input>
            </vm-search>
            <vm-search label="发料状态：">
              <el-select v-model="filter.feedingStatus" placeholder="请选择发料状态" clearable>
                <el-option label="待发料" :value="10"/>
                <el-option label="已发料" :value="80"/>
                <el-option label="缺料" :value="20"/>
              </el-select>
            </vm-search>
            <vm-search label="物料编号：">
              <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable/>
            </vm-search>
          </div>
          <div v-show="searchShow">
            <vm-search label="物料名称：">
              <el-input v-model.trim="filter.materialName" placeholder="请输入物料名称" clearable/>
            </vm-search>
            <vm-search label="物料规格：">
              <el-input v-model.trim="filter.materialSpecification" placeholder="请输入物料规格" clearable/>
            </vm-search>
            <vm-search label="工单编号：">
              <el-input v-model.trim="filter.productionOrderNo" placeholder="请输入工单编号" clearable/>
            </vm-search>
            <vm-search label="派工单号：">
              <el-input v-model.trim="filter.billNo" placeholder="请输入派工单号" clearable/>
            </vm-search>
            <vm-search label="工单类型：">
              <el-select v-model="filter.productionOrderType" placeholder="请选择工单类型" clearable>
                <el-option label="销售订单" :value="1"/>
                <el-option label="自制工单" :value="2"/>
              </el-select>
            </vm-search>
            <vm-search label="工艺路线：">
              <el-input v-model.trim="filter.routingName" placeholder="请输入工艺路线名称" clearable/>
            </vm-search>
            <vm-search label="开工日期：">
              <el-date-picker
                  v-model="dateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange"/>
            </vm-search>
            <vm-search label="完工日期：">
              <el-date-picker
                  v-model="finishDateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="finishDateRangeChange"/>
            </vm-search>
          </div>
        </template>
        <el-table-column align="center" width="55" type="radio" prop="selection">
          <template slot-scope="scope">
            <el-radio v-model="currentRowIndex" :label="scope.$index" @change="selectedRow(scope.row, scope.$index)"/>
          </template>
        </el-table-column>
        <el-table-column prop="productionOrderNo" align="center" label="工单编号" width="140"/>
        <el-table-column prop="billNo" align="center" label="派工单号" width="140"/>
        <el-table-column prop="prodOrderTypeName" align="center" label="工单类型" width="100"/>
        <el-table-column prop="materialNo" align="left" label="物料编号" width="150"/>
        <el-table-column prop="materialName" align="left" label="物料名称" min-width="400"/>
        <el-table-column
            prop="feedingStatusName"
            align="center"
            fixed="right"
            label="发料状态"
            width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.feedingStatus === 10" style="color: orange">{{scope.row.feedingStatusName}}</span>
            <span v-else-if="scope.row.feedingStatus === 80" style="color: green">{{scope.row.feedingStatusName}}</span>
            <span v-else style="color: red">{{scope.row.feedingStatusName}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="workCenterName" align="left" label="工作中心" width="140"/>
        <el-table-column prop="routingName" align="left" label="工艺路线" width="140"/>
        <el-table-column label="派工单数量" align="center" prop="quantity" width="90"/>
        <el-table-column align="center" label="单位" prop="unitName" width="60"/>
        <el-table-column prop="planStartTime" align="center" label="开工时间" width="150"/>
        <el-table-column prop="planFinishTime" align="center" label="完工时间" width="150"/>
      </vm-table>
      <div>
        <el-tabs v-if="productionOrderId">
          <el-tab-pane label="发料清单">
            <el-table v-loading="bomLoading" :data="bomList" border align="left">
              <el-table-column
                  type="expand"
                  width="60">
                <template slot-scope="scope">
                  <el-table
                      :data="scope.row.rowDetail">
                    <el-table-column prop="locationName" label="库位名称" align="center"/>
                    <el-table-column prop="code" label="库位号" align="center"/>
                    <el-table-column prop="quantity" label="库存数量" align="center"/>
                    <el-table-column prop="note" label="备注" align="center"/>
                  </el-table>
                </template>
              </el-table-column>
              <el-table-column prop="materialNo" align="left" label="物料编号" width="150"/>
              <el-table-column prop="materialName" align="left" label="物料名称" min-width="160"/>
              <el-table-column prop="quantity" align="center" label="需求数量" width="100"/>
              <el-table-column prop="materialTypeName" align="center" label="物料类型" width="100"/>
              <el-table-column prop="feedingTypeName" align="center" label="投料类型" width="100"/>
              <el-table-column prop="specification" align="center" label="规格型号" width="240"/>
              <el-table-column prop="materialLength" align="center" label="长" width="60"/>
              <el-table-column prop="materialWidth" align="center" label="宽" width="60"/>
              <el-table-column prop="materialHeight" align="center" label="高" width="60"/>
              <el-table-column prop="materialWeight" align="center" label="净重" width="60"/>
              <el-table-column prop="unitName" align="center" label="单位" width="60"/>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-main>
    <!-- 打印发料单 -->
    <print-issue ref="printIssue"/>
    <work-center-select ref="workCenterSelect" @select="workCenterSelect"/>
  </el-container>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import PrintIssue from "./PrintIssue";
  import WorkCenterSelect from "@/views/information/WorkCenter/WorkCenterSelect";
  export default {
    components: { VmTable, VmSearch, PrintIssue,WorkCenterSelect },
    data() {
      return {
        currentRowIndex: "",
        orderInfo: "", // 工单信息
        bomLoading: false,
        bomList: [],
        productionOrderId: 0,
        dateRange: "",
        searchShow: false,
        finishDateRange: "",
        filter: {
          lackMaterial:true,
          isScheduled: 2,
        },
      };
    },
    mounted() {
      this.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },

      workCenterSelect(row) {
        this.filter.workCenterName = row.workCenterName;
        this.getList(1);
      },

      dateRangeChange(date) {
        if (date) {
          this.filter.planStartFrom = date[0];
          this.filter.planStartTo = date[1];
        } else {
          this.filter.planStartFrom = "";
          this.filter.planStartTo = "";
        }
      },

      finishDateRangeChange(date) {
        if (date) {
          this.filter.planFinishFrom = date[0];
          this.filter.planFinishTo = date[1];
        } else {
          this.filter.planFinishFrom = "";
          this.filter.planFinishTo = "";
        }
      },

      handleClick() {
        this.dateRange = [];
        this.finishDateRange = [];
      },

      // 查询发料明细
      getBomList() {
        this.bomLoading = true;
        this.$http
          .get("basic", `taskDispatchBills/${this.productionOrderId}`)
          .then((resp) => {
            if (resp.success) {
              console.log("aaaa:",resp);
              this.orderInfo = resp.data;
              this.bomList = resp.data.bomList;
              resp.data.bomList.forEach((item,index)=>{
                this.$http.get("basic",`stockDetails/getBySumStockDetail/${item.pkid}`).then((resp)=>{
                  this.bomList[index].rowDetail = resp.data;
                });
              });
            }
            this.bomLoading = false;
          })
          .catch(() => {
            this.bomLoading = false;
          });
      },

      rowClick(row) {
        const tableData = this.$refs.vmTable.tableData;
        tableData.forEach((item, index) => {
          if (item.pkid === row.pkid) {
            this.currentRowIndex = index;
            this.orderInfo = row;
            this.productionOrderId = row.pkid;
            this.getBomList();
          }
        });
      },

      selectedRow(row, index) {
        this.currentRowIndex = index;
        this.orderInfo = row;
        this.productionOrderId = row.pkid;
      },

      setSelectedRow(val) {
        this.rowClick(val);
      },
    },
  };
</script>
